import 'flickity/dist/flickity.pkgd.js';
import 'lightcase';
import Flickity from 'flickity';
import 'bootstrap';
import 'viewerjs/dist/viewer.min.js';
import 'jquery-viewer/dist/jquery-viewer.min.js';

import Nav from '../lib/Nav';
import collapse from 'bootstrap/js/dist/collapse';

var shrinkHeader = 5;

Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};

export default {
  init() {
    // JavaScript to be fired on all pages
    new Nav();
    Flickity.defaults.dragThreshold = 3;

    var collapseElementList = [].slice.call(
      document.querySelectorAll('.collapse')
    );
    // eslint-disable-next-line no-unused-vars
    var collapseList = collapseElementList.map(function (collapseEl) {
      return new collapse(collapseEl, {
        toggle: false,
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    let $homeTestimonials = $('.testimonial-slider');

    if ($homeTestimonials.length > 0) {
      console.log('slider');
      $homeTestimonials.flickity({
        freeScroll: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        adaptiveHeight: true,
      });
    }

    let $moreNews = $('.more-news-section .news-items-row');
    if ($moreNews.length > 0) {
      $moreNews.flickity({
        freeScroll: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left',
        watchCSS: true,
      });
    }

    /*
    Popup page
    */

    // Disable Popup on successful submit
    $('#_form_17_submit').on('click', function () {
      console.log('Submit Clicked');
      localStorage.setItem('popupDisablePermanent','enabled');
      setTimeout(function() {
        if ($('._form-content').find('input._has_error').length !== 0) {
          localStorage.removeItem('popupDisablePermanent','enabled');
        }
      }, 1000);
    });

    // Create a local varibale for first time visit
    if (!localStorage.getItem('numberOfVisits')) {
      localStorage.setItem('numberOfVisits', 0);
    }

    // Check for last visit date and remove time limitations
    if (localStorage.getItem('lastVisitDate')) {
      if (Date.now() > parseInt(localStorage.getItem('lastVisitDate'))+5259600000) {
        localStorage.removeItem('popupDisableTemporary');
        localStorage.setItem('numberOfVisits', 0);
      }
    }

    // Check for number of visits and create session
    if (parseInt(localStorage.getItem('numberOfVisits'))<3 && !sessionStorage.getItem('numberOfVisitsSession') && !localStorage.getItem('popupDisablePermanent') && !localStorage.getItem('popupDisableTemporary')) {
      let NewVisitValue = parseInt(localStorage.getItem('numberOfVisits')) + 1;
      localStorage.setItem('numberOfVisits', NewVisitValue);
      sessionStorage.setItem('numberOfVisitsSession', 'session_active');
      localStorage.setItem('lastVisitDate', Date.now());
    }

    // Open popup is session is active
    if (sessionStorage.getItem('numberOfVisitsSession') == 'session_active' ) {
      sessionStorage.setItem('numberOfVisitsSession', 'session_deactive');

      $('#popupFormModal').modal('show');
    }

    // Popup close button
    $('.active-campaign-popup .close-button').on('click', function () {
      $('.active-campaign-popup').modal('hide');
    });

    /*
    Popup page
    */

    let $answer = $('.questionnaire .answer');

    $answer.on('click', function (e) {
      e.preventDefault();

      let $currentQuestion = $(this).closest('.question-wrapper');
      let $nextQuestion = $(this)
        .closest('.question-wrapper')
        .next('.question-wrapper');

      let $selectedAnswer = $(this);
      let $nextQuestionActivatedAnswerSet = $nextQuestion.find(
        '[data-answer-related=\'' + this.dataset.answer + '\']'
      );

      // Link to next question
      if (this.dataset.nextQuestion == 'true') {
        $currentQuestion.addClass('answered');
        $currentQuestion.removeClass('active');
        $selectedAnswer.addClass('selected');

        $nextQuestion.addClass('active');
        $nextQuestionActivatedAnswerSet.removeClass('d-none');
        $nextQuestionActivatedAnswerSet.addClass('active');
      } else {
        window.location = $(this).attr('href');
      }
    });

    // Add lightbox to valid WordPress images
    ['jpg', 'jpeg', 'gif', 'png', 'svg', 'bmp'].forEach(mime => {
      $('[href$=".' + mime + '"]').lightcase();
    });
    $('[data-rel^="lightcase"]').lightcase({
      maxWidth: 1200,
      maxHeight: 1000,
      forceWidth: 600,
      iframe: {
        width: 1200,
        height: 675,
      },
      shrinkFactor: 0.95,
    });

    $('a[data-rel^=video-player]').lightcase({
      video : {
        width : 400,
        height : 225,
        poster : '',
        preload : 'auto',
        controls : true,
        autobuffer : true,
        autoplay : true,
        loop : false,
      },
      overlayOpacity: .8,
    });

    megaNavContent();
    megaNavContentHome();
    megaNavClickDisable();
    megaNavMobileLink();
    jqueryViewer('#gallery-images-viewer-v2');
    jqueryViewer('#gallery-images-viewer-v1');
    videoPopupPlayer();
    fullWidthVideoPlayer();
    gallerySectionSlider()
  },
};

$(window).on('resize', function () {
  $(
    '.gallery-section.v1 .section-inner-wrp .gallery-wrapper').flickity('resize');
});

$(window).on('load', function () {
  $('.testimonial-slider, .more-news-section .news-items-row, .gallery-section.v1 .section-inner-wrp .gallery-wrapper').flickity('resize');

  // main menu add a class to set scrollbar
  setTimeout(function(){
    if($('.nav-primary').outerHeight() > 530) {
      $('.nav-primary').addClass('has-scrollbar');
    } else {
      $('.nav-primary').removeClass('has-scrollbar');
    }
  }, 800);
});

function getCurrentScroll() {
  return window.pageYOffset || document.documentElement.scrollTop;
}

$(window).scroll(function () {
  var scroll = getCurrentScroll();
  if (scroll >= shrinkHeader) {
    $('body, .header-container').addClass('sticky-active');
  } else {
    $('body, .header-container').removeClass('sticky-active');
  }
});

function gallerySectionSlider() {
  var cellAlignValue = '';

  if (matchMedia('screen and (max-width: 768px)').matches) {
    cellAlignValue = 'center';
  } else {
    cellAlignValue = 'left';
  }

  $('.gallery-section.v1 .section-inner-wrp .gallery-wrapper').flickity({
    pageDots: true,
    prevNextButtons: true,
    wrapAround: true,
    cellAlign: cellAlignValue,
  });
}

// Implementation of Jquery Viewer
function jqueryViewer(ulId) {
  var $galleryImages = $(ulId);
  console.log($galleryImages);

  $galleryImages.viewer({
    tooltip: 0,
    inline: false,
    toolbar: {
      zoomIn: {
        show: 1,
        size: 'large',
      },
      zoomOut: {
        show: 1,
        size: 'large',
      },
      oneToOne: 0,
      reset: 0,
      prev: {
        show: 1,
        size: 'large',
      },
      play: {
        show: 0,
        size: 'large',
      },
      next: {
        show: 1,
        size: 'large',
      },
      rotateLeft: 0,
      rotateRight: 0,
      flipHorizontal: 0,
      flipVertical: 0,
    },
    title: 0,
  });
}
// Implementation of Jquery Viewer

// Full Width Video Player
function fullWidthVideoPlayer() {
  for (let i = 1; i <= $('.playvideo').length ; i++) {
    let idName = 'play-video-' + i;
    let newIdName = 'video-iframe-' + i;
    $('.playvideo')[i-1].setAttribute('id', idName);
    $('.iframe-video')[i-1].setAttribute('id', newIdName);
    $('#'+idName).click(function(){

      if ($('#'+newIdName).hasClass('video-element')) {
        $('#'+ newIdName).css('opacity','1');
        $('#'+ newIdName).get(0).play();
        $('#' + idName).css({
          'opacity' : '0',
          'z-index' : '-1',
        });
      } else {
        $('#'+ newIdName).css('opacity','1');
        $('#'+ newIdName)[0].src += '&autoplay=1';
        $('#' + idName).css({
          'opacity' : '0',
          'z-index' : '-1',
        });
      }
    });
  }
}
// Full Width Video Player

// Popup Video Player for Two Column Section
function videoPopupPlayer() {
  var $videoSrc;
  $('.video-iframe-thumbnail').click(function () {
    $videoSrc = $(this).data('src');
  });

  $('#myModal').on('shown.bs.modal', function () {
    $('#video').attr(
      'src',
      $videoSrc + '?autoplay=1&mute=1&amp;modestbranding=1&amp;showinfo=0'
    );
  });

  $('#myModal').on('hide.bs.modal', function () {
    $('#video').attr('src', $videoSrc);
  });
}
// Popup Video Player for Two Column Section

/**
 * Contact Form 7 events
 */
document.addEventListener(
  'wpcf7mailsent',
  function (event) {
    if (event.detail.contactFormId === '411' && window.ebookUrl) { // download form
      let link = document.createElement('a');
      link.href = window.ebookUrl;
      link.download = window.ebookUrl;
      link.dispatchEvent(new MouseEvent('click'));
    }
  },
  false
);

function checkClassChangeMegaNav() {
  if ($('.mega-menu > li.mega-menu-item').hasClass('mega-toggle-on')) {
    $('body').addClass('mega-nav-open');
  } else {
    $('body').removeClass('mega-nav-open');
  }

  setTimeout(checkClassChangeMegaNav, 10);
}

function megaNavContentHome() {
  //always show first item on hover - others are hidden until hovered
  $('.header-container-home .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:last-child .mega-menu-item-type-widget:first-child').addClass('show');
  //always show first item on hover - others are hidden until hovered

  //add class to li item to make active color
  $('.header-container-home .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:first-child li:first-child p').addClass('mega-sub-active');
  //add class to li item to make active color

  // check if mega nav is opened to add class to body when it does
  checkClassChangeMegaNav();
  // check if mega nav is opened to add class to body when it does

  // get href value to array
  var contentText = new Array();
  var hrefValue = '';
  var dynamicReplacement = '';

  $('.header-container-home .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:first-child .mega-menu-item-type-widget').each(function() {
    //making unique id's for home header only due to conflicts of having 2 headers
    dynamicReplacement = $(this).parents('.mega-menu-item').first().children('.mega-menu-link').text().replace(/\s+/g, '-').toLowerCase();
    //making unique id's for home header only due to conflicts of having 2 headers

    contentText.push($(this).find('.textwidget p a').attr('href').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLowerCase() + '-' + dynamicReplacement);

  });
  // get href value to array

  // assign array value to other column list id
  $('.header-container-home .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:first-child .mega-menu-item-type-widget').each(function(index) {
    // $(this).find('a').attr('id', contentText[index]);
    $(this).find('a').addClass(contentText[index]);
  });
  // assign array value to other column list id

  // assign array value to other column list id
   $('.header-container-home .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:last-child .mega-menu-item-type-widget').each(function(index) {
    $(this).attr('id', contentText[index])
  });
  // assign array value to other column list id

  // showing content with same id as href
  $('.header-container-home .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:first-child li a').hover(function () {

    //removing classes for only that section of mega nav without interupting others
    $(this).parents('.mega-menu-column').siblings().children().find('.mega-menu-item-type-widget').removeClass('show');

    $(this).parents('.mega-menu-item-type-widget').siblings().children().find('p').removeClass('mega-sub-active');
    //removing classes for only that section of mega nav without interupting others

    hrefValue = $(this).attr('class');

    $('#'+hrefValue).addClass('show');
    $(this).parent().addClass('mega-sub-active');
  });
  // showing content with same id as href
}

function megaNavContent() {

  //always show first item on hover - others are hidden until hovered
  $('.header-container .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:last-child .mega-menu-item-type-widget:first-child').addClass('show');
  //always show first item on hover - others are hidden until hovered

  //add class to li item to make active color
  $('.header-container .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:first-child li:first-child p').addClass('mega-sub-active');
  //add class to li item to make active color

  // get href value to array
  var contentText = new Array();
  var hrefValue = '';

  $('.header-container .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:first-child .mega-menu-item-type-widget').each(function() {

    // contentText.push($(this).find('.textwidget p a').attr('href').split('#')[1]);
    contentText.push($(this).find('.textwidget p a').attr('href').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLowerCase());

  });
  // get href value to array

  // assign array value to other column list id
  $('.header-container .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:last-child .mega-menu-item-type-widget').each(function(index) {
    $(this).attr('id', contentText[index])
  });
  // assign array value to other column list id

  // showing content with same id as href
  $('.header-container .main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:first-child li a').hover(function () {

    //removing classes for only that section of mega nav without interupting others
    $(this).parents('.mega-menu-column').siblings().children().find('.mega-menu-item-type-widget').removeClass('show');

    $(this).parents('.mega-menu-item-type-widget').siblings().children().find('p').removeClass('mega-sub-active');
    //removing classes for only that section of mega nav without interupting others

    // hrefValue = $(this).attr('href').split('#')[1];
    hrefValue = $(this).attr('href').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLowerCase();

    $('#'+hrefValue).addClass('show');
    $(this).parent().addClass('mega-sub-active');
  });
  // showing content with same id as href
}

function megaNavClickDisable() {
  $('.main-menu-desktop .mega-menu .mega-sub-menu .mega-menu-column:first-child li a').on('click', function (e) {
    if ($(this).attr('href').includes('#')) {
      e.preventDefault();
    }
  });
}

function megaNavMobileLink() {
  //update link on mobile
  var linkMobile = new Array();

  $('.primary-nav-container .mega-menu .mega-sub-menu .mega-menu-column:last-child .mega-menu-item-type-widget').each(function() {
    linkMobile.push($(this).find('.textwidget a').attr('href'));
  });

  $('.primary-nav-container .mega-menu .mega-sub-menu .mega-menu-column:first-child .mega-menu-item-type-widget').each(function(index) {
    $(this).find('.textwidget a').attr('href', linkMobile[index])
  });
  //update link on mobile
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js